<script setup lang="ts">
import { AccordionItem, AccordionHeader, AccordionTrigger, AccordionContent } from 'reka-ui';

withDefaults(
  defineProps<{
    title: string;
    accordionItemIndex: number;
    whiteText?: boolean;
  }>(),
  {
    whiteText: false,
  },
);
</script>

<template>
  <AccordionItem
    :value="title ? `${title}-${accordionItemIndex}` : `item-${accordionItemIndex}`"
    class="border-b border-gray-40"
  >
    <AccordionHeader>
      <AccordionTrigger
        class="accordionTrigger lg:text-2xl flex w-full items-center justify-between py-3 text-left text-lg font-bold"
      >
        <span
          v-if="title"
          :id="`accordion-label-${accordionItemIndex}`"
          class="text-base font-normal lg:text-md"
          :class="{ 'text-white': whiteText }"
        >
          {{ title }}
        </span>

        <BaseIcon
          name="chevron-down"
          aria-hidden="true"
          class="accordionChevron"
          :stroke-color="whiteText ? 'var(--color-white)' : 'var(--color-secondary)'"
          prefix="arrows"
          focusable="false"
        />
      </AccordionTrigger>
    </AccordionHeader>

    <AccordionContent
      :aria-labelledby="`accordion-label-${accordionItemIndex}`"
      class="accordion-content"
    >
      <div class="p-6">
        <slot></slot>
      </div>
    </AccordionContent>
  </AccordionItem>
</template>

<style scoped lang="postcss">
.accordionChevron {
  transition: transform 300ms ease-in-out;
}
.accordionTrigger[data-state='open'] > .accordionChevron {
  transform: rotate(180deg);
}

.accordion-content {
  overflow: hidden;
}
.accordion-content[data-state='open'] {
  animation: slideDown 300ms ease-out;
}
.accordion-content[data-state='closed'] {
  animation: slideUp 300ms ease-out;
}

@keyframes slideDown {
  from {
    height: 0;
  }
  to {
    height: var(--reka-accordion-content-height);
  }
}

@keyframes slideUp {
  from {
    height: var(--reka-accordion-content-height);
  }
  to {
    height: 0;
  }
}
</style>
